<div class="card">
  <div class="back-nav">
    <button mat-stroked-button (click)="goBack()">
      <mat-icon>arrow_back</mat-icon>
      Administration Centre de Compétence
    </button>
  </div>

  <div class="data-header">
    <div class="createBtn" *ngIf="authenticationService.isUserAdmin()">
      <button mat-raised-button color="primary" (click)="openDialog()">
        <mat-icon>add</mat-icon>
        Créer
      </button>
    </div>
    <mat-form-field class="nomenclatureFilter">
      <mat-label>Filtre</mat-label>
      <input matInput (keyup)="nomenclaturesFilter($event)">
    </mat-form-field>
    <div><button mat-raised-button (click)="exportData()" class="indigo createBtn"
        [style.background-color]="theme.getColor('Main Dark')">
        <mat-icon>get_app</mat-icon>
        Export Excel
      </button></div>
  </div>

  <mat-table #table class="mat-elevation-z8 table-container" *ngIf="nomenclatures" [dataSource]="nomenclatures" matSort>

    <ng-container matColumnDef="activiteUOoperationnelle">
      <mat-header-cell *matHeaderCellDef mat-sort-header id="activiteUOoperationnelle">Activité UO
        opérationnelle</mat-header-cell>
      <mat-cell *matCellDef="let element">{{ element.activiteUOoperationnelle }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="nomenclatureLabel">
      <mat-header-cell *matHeaderCellDef mat-sort-header id="nomenclatureLabel">Label nomenclature</mat-header-cell>
      <mat-cell *matCellDef="let element">{{ element.nomenclatureLabel }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="prixUO">
      <mat-header-cell *matHeaderCellDef mat-sort-header id="prixUO">Prix UO</mat-header-cell>
      <mat-cell *matCellDef="let element">{{ element.prixUO }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="prixUOmajore">
      <mat-header-cell *matHeaderCellDef mat-sort-header id="prixUOmajore">Prix UO majoré</mat-header-cell>
      <mat-cell *matCellDef="let element">{{ element.prixUOmajore }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="actions">
      <mat-header-cell *matHeaderCellDef id="actions" class="actions-td">Actions</mat-header-cell>
      <mat-cell *matCellDef="let element" class="actions-td">
        <button mat-icon-button (click)="selectedNomenclaturePencil(element)"
          [disabled]="!authenticationService.isUserAdmin()">
          <mat-icon>mode_edit</mat-icon>
        </button>
        <button mat-icon-button (click)="removeNomenclature(element)" [disabled]="!authenticationService.isUserAdmin()">
          <mat-icon>delete</mat-icon>
        </button>
      </mat-cell>
    </ng-container>

    <mat-header-row mat-header-row *matHeaderRowDef="displayedColumns; sticky: true;"></mat-header-row>
    <mat-row mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
  </mat-table>
</div>